export const paths = {
    ADMIN: 'admin',
    API_CLONEABLEGAME: 'api/cloneablegame',
    API_CREATEGAME: 'api/creategame',
    API_GAME: 'api/game',
    API_GAME_HISTORY: 'api/game/history',
    API_GAME_LOGS: 'api/game/logs',
    API_GAMES: 'api/games',
    API_HEAP_SNAPSHOT: 'api/heapsnapshot',
    API_IPS: 'api/ips',
    API_METRICS: 'api/metrics',
    API_LOGOUT: 'api/logout',
    API_PLAYER: 'api/player',
    API_PROFILE: 'api/profile',
    API_JUDGE: 'api/judge',
    API_JUDGE_REWIND: 'api/judge/rewind',
    API_JUDGE_FREEZE: 'api/judge/freeze',
    API_REPLAY_MOVES: 'api/replay/moves',
    API_REPLAY_VIEW: 'api/replay/view',
    API_REWIND: 'api/rewind',
    API_REWIND_VOTE: 'api/rewind/vote',
    API_SPECTATOR: 'api/spectator',
    API_STATS: 'api/stats',
    API_WAITING_FOR: 'api/waitingfor',
    AUTH_DISCORD_CALLBACK: 'auth/discord/callback',
    AUTOPASS: 'autopass',
    CARDS: 'cards',
    END_GAME_LOG: 'end_game_log',
    GAME: 'game',
    GAMES_OVERVIEW: 'games-overview',
    HELP: 'help',
    LOAD: 'load',
    LOAD_GAME: 'load_game',
    LOGIN: 'login',
    NEW_GAME: 'new-game',
    PLAYER: 'player',
    PLAYER_INPUT: 'player/input',
    REPLAY: 'replay',
    RESET: 'reset',
    JUDGE: 'judge',
    SPECTATOR: 'spectator',
    THE_END: 'the-end',
};
